// import React, { Fragment } from "react";
import React, { Fragment, useEffect, useState } from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Input from "./Input";
import FormikControl from "../CustomedFields/FormikControl";

function CheckBox_MeasurementSetting(props) {
  const [isChecked, setIsChecked] = useState();
  const [hiddenValue, setHiddenValue] = useState("");
  const [checkBoxName, setCheckBoxName] = useState("");

  const handleCheckboxChange = (event) => {
    // alert(event.target.checked);

    const name = event.target.name;
    if (event.target.checked) {
      props.add_CheckboxChange_Item(name);
    } else {
      props.remove_CheckboxChange_Item(name);
    }

    // !item.value || item.value == "" ? false : true
    // alert("event.target.checked" + event.target.checked);
    setIsChecked(!isChecked);

    if (!isChecked) {
      setHiddenValue("true");
    } else {
      setHiddenValue("false");
    }
  };

  useEffect(() => {
    //alert("checkBox_Value_DB" + props.value);
    // setCheckBoxName(props.name + "_CheckBox");
    setCheckBoxName(props.name);

    // let checkValue =
    //   !props.value ||
    //   props.value == "" ||
    //   props.value == "undefined" ||
    //   props.value === "False" ||
    //   props.value !== "True"
    //     ? false
    //     : true;
    let checkValue = props.value === "True" ? true : false;

    // alert("checkValue -- " + checkValue + " -- props.value -- " + props.value);

    if (checkValue == false) {
      setIsChecked(false);
      setHiddenValue("false");
    } else {
      setIsChecked(true);
      setHiddenValue("true");
    }
  }, []);

  return (
    <Fragment>
      {/* <div className="form-control-customed single_input" style={props.style}> */}
      <div className="form-control-customed single_input_width_100percent" style={props.style}>
        <div className="form-control-customed" style={{ paddingTop: "7px" }}>
          <input
            name={props.name}
            type="checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />{" "}
          &nbsp;
          <span className="text-sm">
            {props.label}
            {/* {props.name} */}
          </span>
        </div>
      </div>

      {/* <Field
        type="text"
        className="single_input_text"
        id={props.name}
        name={checkBoxName}
        value={hiddenValue}
        // {...rest}
      /> */}

      {/* <FormikControl
        control="Input_libas_extendNote"
        type="text"
        label={props.name}
        name={props.name}
        value={hiddenValue}
      /> */}

      {/* <button
        onClick={() => {
          props.edit_measurementSettingsDetailsByGUID(
            props.guid,
            props.isExtendedNote
          );
        }}
        type="button"
        className="btn btn-light"
      >
        <i className="fa fa-edit"></i>
      </button>
      &nbsp;
      <button
        onClick={() => {
          props.delete_MeasurementSettingsDetailsByGUID(props.guid);
        }}
        type="button"
        className="btn btn-light"
      >
        <i className="fa fa-trash"></i>
      </button> */}
    </Fragment>
  );
}

export default CheckBox_MeasurementSetting;
